import axios from 'axios'

let STATE = {
  get JWT () {
    return window.localStorage.getItem('igetyo-jwt')
  },
  set JWT (v) {
    return window.localStorage.setItem('igetyo-jwt', v)
  }
}

// export const register = ({ username, email, password }) => {
//   // Request API.
//   // Add your own code here to customize or restrict how the public can register new users.
//   axios.create({
//   })
//     .post(`${getBase()}/auth/local/register`, {
//       username,
//       email,
//       password
//     })
//     .then(response => {
//       // Handle success.
//       console.log('Well done!')
//       console.log('User profile', response.data.user)
//       console.log('User token', response.data.jwt)
//     })
//     .catch(error => {
//       // Handle error.
//       console.log('An error occurred:', error)
//     })
// }

// export const login = ({ username, email, password }) => {
//   axios.create({
//   })
//     .post(`${getBase()}/auth/local/login`, {
//       username,
//       email,
//       password
//     })
//     .then(response => {
//       // Handle success.
//       console.log('Well done!')
//       console.log('User profile', response.data.user)
//       console.log('User token', response.data.jwt)
//     })
//     .catch(error => {
//       // Handle error.
//       console.log('An error occurred:', error)
//     })
// }

// export const getMyself = () => {
//   axios.create({
//     headers: {
//       Authorization: `Bearer ${STATE.JWT}`
//     }
//   })
//     .post('/me')
//     .then(resp => {
//       console.log(resp.data)
//       return resp.data
//     })
// }

/*

ssh-keygen -t rsa -b 4096 -m PEM -f jwtRS256.key
# Don't add passphrase
openssl rsa -in jwtRS256.key -pubout -outform PEM -out jwtRS256.key.pub
cat jwtRS256.key
cat jwtRS256.key.pub

*/

export const getConfig = () => {
  let headers = {
  }
  if (typeof STATE.JWT === 'string' && STATE.JWT !== 'undefined') {
    headers.Authorization = `Bearer ${STATE.JWT}`
  }
  return {
    headers,
    baseURL: `https://api.igetyo.com`
  }
}

export const getNameSpaceBySpaceID = ({ spaceID }) => {
  return axios.create(getConfig())
    .post('/namespaces/findByID', {
      spaceID
    })
    .then((resp) => {
      return resp.data[0]
    })
}

export const updateSpaceIDContent = ({ spaceID, password, content }) => {
  return axios.create(getConfig())
    .post('/namespaces/updateContent', {
      spaceID,
      password,
      content
    })
    .then((resp) => {
      return resp.data[0]
    })
}

export const changePassword = ({ spaceID, password, newPassword }) => {
  return axios.create(getConfig())
    .post('/namespaces/changePassword', {
      spaceID,
      password,
      newPassword
    })
    .then((resp) => {
      return resp.data
    })
}

export const checkLogin = ({ spaceID, password }) => {
  return axios.create(getConfig())
    .post('/namespaces/echo', {
      spaceID,
      password
    })
    .then((resp) => {
      return resp.data
    })
}

export const createSpace = ({ spaceID, password, content }) => {
  return axios.create(getConfig())
    .post('/namespaces/createSpace', {
      spaceID,
      password,
      content
    })
    .then((resp) => {
      return resp.data
    })
}
